// extracted by mini-css-extract-plugin
export default {"header":"style_header__1FKHM","cancel":"style_cancel__rpuTm","confirm":"style_confirm__2v9O3","title":"style_title__6pnfU"};